import { useCallback, useEffect, useState } from "react";
import { usePublicClient } from "wagmi";
import { erc20Abi, zeroAddress } from "viem";
import { factoryV3Abi, poolV3Abi, lpAddr } from "../lib/npm";

export const sortPair = (a, b) => (a.toLowerCase() < b.toLowerCase() ? [a, b] : [b, a]);

// Reads a Uniswap v3 pool for base/quote/fee directly from the chain.
export function usePoolState({ cfg, base, quote, fee }) {
  const pc = usePublicClient({ chainId: 4663 });
  const [s, setS] = useState({ loading: false });
  const load = useCallback(async () => {
    if (!base || !quote || !pc) return setS({ loading: false });
    const b = lpAddr(base, cfg), q = lpAddr(quote, cfg);
    if (b.toLowerCase() === q.toLowerCase()) return setS({ loading: false, error: "Base and quote must be different tokens" });
    const [t0, t1] = sortPair(b, q);
    const baseIsToken0 = t0 === b;
    const d0 = baseIsToken0 ? base.decimals : quote.decimals;
    const d1 = baseIsToken0 ? quote.decimals : base.decimals;
    setS((x) => ({ ...x, loading: true, error: null }));
    try {
      const pool = await pc.readContract({ address: cfg.contracts.UniswapV3Factory, abi: factoryV3Abi, functionName: "getPool", args: [t0, t1, fee] });
      const common = { t0, t1, d0, d1, baseIsToken0, fee };
      if (pool === zeroAddress) return setS({ loading: false, exists: false, ...common });
      const [slot0, liquidity, r0, r1] = await pc.multicall({ allowFailure: false, contracts: [
        { address: pool, abi: poolV3Abi, functionName: "slot0" }, { address: pool, abi: poolV3Abi, functionName: "liquidity" },
        { address: t0, abi: erc20Abi, functionName: "balanceOf", args: [pool] }, { address: t1, abi: erc20Abi, functionName: "balanceOf", args: [pool] }] });
      setS({ loading: false, exists: true, pool, sqrtP: slot0[0], tick: Number(slot0[1]), initialized: slot0[0] > 0n, liquidity, r0, r1, ...common });
    } catch (e) {
      setS({ loading: false, error: `RPC error reading pool: ${e.shortMessage || e.message}` });
    }
  }, [pc, cfg, base, quote, fee]);
  useEffect(() => { load(); }, [load]);
  return { ...s, reload: load };
}
